import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/reevesdotnl/reevesdotnl/src/templates/pdf-view.tsx";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`A landmark paper on the paleotectonics of Africa is in the review stage. A draft version is curently available in ResearchGate at the following link:`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.researchgate.net/publication/382745358_A_Paleotectonic_Atlas_of_the_African_Plate_Permian_to_Recent_Draft"
      }}>{`here`}</a></p>
    <p>{`Dancan Macgregor draws on a lifetime's experience of petroleum exploration in Africa and a great deal of data revealed not only in the published literature but also
in presentations at specialist conferences over many years to produce an atlas of tectonic events across the whole of Africa from Permian times to the present. The
base maps are taken from the plate-tectonic model of Gondwana dispersion explained elsewhere on `}<a parentName="p" {...{
        "href": "https://www.reeves.nl/gondwana"
      }}>{`this website`}</a>{`.`}</p>
    <p>{`The draft version has already had over 700 reads and the published version, expected later this year, will undoubtedly serve as a foundation stone for petroleum
exploration across the continent for many years to come.`}</p>
    <hr></hr>
    <p><em parentName="p">{`2025 February 3`}</em></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      